import { createApiSaga } from '../../../sagaGenerator';
import { apiDelete, apiGet } from '../../../../middleware/api';
import {
  DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_REQUEST,
  DEPOSIT_RELATED_TSUNAMIS_PUBLICATION_REQUEST,
  DEPOSIT_RELATED_TSUNAMIS_GEOAGE_REQUEST,
  DEPOSIT_RELATED_TSUNAMIS_DEPOSIT_REQUEST,
  DEPOSIT_RELATED_TSUNAMIS_DELETE_REQUEST,
  DEPOSIT_RELATED_TSUNAMIS_PUBLICATION_FAILURE,
  DEPOSIT_RELATED_TSUNAMIS_PUBLICATION_SUCCESS,
  DEPOSIT_RELATED_TSUNAMIS_GEOAGE_FAILURE,
  DEPOSIT_RELATED_TSUNAMIS_GEOAGE_SUCCESS,
  DEPOSIT_RELATED_TSUNAMIS_DELETE_FAILURE,
  DEPOSIT_RELATED_TSUNAMIS_DELETE_SUCCESS,
  DEPOSIT_RELATED_TSUNAMIS_DEPOSIT_FAILURE,
  DEPOSIT_RELATED_TSUNAMIS_DEPOSIT_SUCCESS,
  DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_FAILURE,
  DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_SUCCESS,
} from './depositRelatedTsunamisReducer';

const getDepositSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/tsunamis/deposits/${action.id}/info`, ...action }),
  requestType: DEPOSIT_RELATED_TSUNAMIS_DEPOSIT_REQUEST,
  successType: DEPOSIT_RELATED_TSUNAMIS_DEPOSIT_SUCCESS,
  failureType: DEPOSIT_RELATED_TSUNAMIS_DEPOSIT_FAILURE,
});

const getTsunamisSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/tsunamis/deposits/${action.id}/tsunamis`, ...action }),
  requestType: DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_REQUEST,
  successType: DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_SUCCESS,
  failureType: DEPOSIT_RELATED_TSUNAMIS_TSUNAMI_FAILURE,
});

const deleteTsunamiEventSaga = createApiSaga({
  apiFunction: apiDelete,
  generateApiConfig: action => ({ endpoint: `/tsunamis/events/${action.id}`, ...action }),
  requestType: DEPOSIT_RELATED_TSUNAMIS_DELETE_REQUEST,
  successType: DEPOSIT_RELATED_TSUNAMIS_DELETE_SUCCESS,
  failureType: DEPOSIT_RELATED_TSUNAMIS_DELETE_FAILURE,
  successMessage: 'Deleted',
});

const getGeoagesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/deposit/geologic-ages', ...action }),
  requestType: DEPOSIT_RELATED_TSUNAMIS_GEOAGE_REQUEST,
  successType: DEPOSIT_RELATED_TSUNAMIS_GEOAGE_SUCCESS,
  failureType: DEPOSIT_RELATED_TSUNAMIS_GEOAGE_FAILURE,
});

const getPublicationsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunami/deposit/publication-types', ...action }),
  requestType: DEPOSIT_RELATED_TSUNAMIS_PUBLICATION_REQUEST,
  successType: DEPOSIT_RELATED_TSUNAMIS_PUBLICATION_SUCCESS,
  failureType: DEPOSIT_RELATED_TSUNAMIS_PUBLICATION_FAILURE,
});


export const depositRelatedTsunamiSagas = [
  getDepositSaga,
  deleteTsunamiEventSaga,
  getTsunamisSaga,
  getGeoagesSaga,
  getPublicationsSaga,
];
